import axios from 'axios'

import { SEARCH_ENDPOINT} from '@helpers/request'
import {cleanUrlParam} from '@helpers/urlHelpers'

export default async function (parameters) {
  const params = cleanUrlParam(parameters)
  const url = SEARCH_ENDPOINT + params;
  return await axios.get(url)
}
